export const LINE_ITEM = 'LINE_ITEM';
export const BRAND = 'BRAND';
export const CATEGORY = 'CATEGORY';
export const PRODUCT_ATTRIBUTE = 'PRODUCT_ATTRIBUTE';
export const ATTRIBUTE = 'ATTRIBUTE';
export const SKU = 'SKU';
export const SKU_UPLOAD = 'SKU_UPLOAD';
export const SKU_SELECT = 'SKU_SELECT';
